import { fetchJournals } from '~shared/api/getJournalsData/utils/fetchJournals'
import { TGetJournalsDataProps } from './types'
import { normalizeJournalsData } from '~shared/api/getJournalsData/utils/normalizeJournalsData'

export const getJournalsData = async ({
  context,
  amount,
  filterBy,
  start
}: TGetJournalsDataProps) => {
  try {
    const journalsData = await fetchJournals({
      context,
      amount,
      filterBy,
      start
    })

    const journalsDataNormalized = normalizeJournalsData({
      journalsData
    })

    return journalsDataNormalized
  } catch (e) {
    console.log('%cgetJournalsData.ts line:8 e', 'color: #007acc;', e)
  }
  return null
}
